import React from "react";
import { Button, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const RegistrationSuccessful = () => {
  const navigate = useNavigate();
  const { brokerDetailedInfo } = useSelector((state) => state);

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";

  var backgroundStyle = "";

  if (brokerDetailedInfo?.color?.isBackgroundImage == 0) {
    // console.log('in if block');

    backgroundStyle = {
      background: frontPagebakgColor,
    };
  } else {
    // console.log('in else block');

    backgroundStyle = {
      backgroundImage: `url(${brokerDetailedInfo?.color?.backgroundImageLink})`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `cover`,
      backgroundPosition: `center`,
      minHeight: `100%`,
    };
  }

  return (
    <div
      className="d-flex align-items-center"
      style={{ ...backgroundStyle, height: "100%" }}
    >
      <Container
        style={{
          backgroundColor: "#dfdada",
          padding: "30px 13%",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          maxWidth: "950px",
          margin: "20px auto",
          height: "510px",
        }}
      >
        <div className="d-flex justify-content-center">
          <FontAwesomeIcon
            icon={faUserCheck}
            color="#7ab4f3"
            style={{ height: "150px", width: "105px" }}
          />
        </div>

        <h3
          className="text-center mb-4 text-dark"
          style={{ fontWeight: "700", fontSize: "28px", paddingTop: "15px" }}
        >
          Well done ! You have successfully registered to{" "}
          {localStorage.getItem("exchange")}. Your crypto journey begins here.
        </h3>
        <Button
          variant="primary"
          type="submit"
          className="w-100 mb-3"
          style={{
            height: "60px",
            fontSize: "25px",
            fontWeight: "bold",
            marginTop: "45px",

            backgroundColor: brokerDetailedInfo?.color?.buttonColor,
            borderColor: brokerDetailedInfo?.color?.buttonColor,
          }}
          onClick={() => navigate("/login")}
        >
          Click here to login
        </Button>
      </Container>
    </div>
  );
};

export default RegistrationSuccessful;
